export const getItem = (key, isPersistent = false)=>{
    let value = undefined;
    try {
        value = isPersistent ? localStorage.getItem(key) : sessionStorage.getItem(key);
        if (value === null || value === '') {
            return undefined;
        }
        return JSON.parse(value);
    } catch  {
        return value;
    }
};
export const setItem = (key, value, isPersistent = false)=>{
    const stringifiedValue = typeof value === 'string' ? value : JSON.stringify(value);
    if (isPersistent) {
        localStorage.setItem(key, stringifiedValue);
    } else {
        sessionStorage.setItem(key, stringifiedValue);
    }
};
export const removeItem = (key, isPersistent = false)=>{
    if (isPersistent) {
        localStorage.removeItem(key);
    } else {
        sessionStorage.removeItem(key);
    }
};
export const findItem = (key)=>{
    return getItem(key) ?? getItem(key, true);
};
export const popItem = (key, isPersistent = false)=>{
    const value = getItem(key, isPersistent);
    removeItem(key, isPersistent);
    return value;
};

//# sourceMappingURL=storage.js.map